import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface HighlightedQuoteProps {
  children: React.ReactNode;
  author?: string;
}
export function HighlightedQuote({
  children,
  author
}: HighlightedQuoteProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6
  }} className="my-10 md:my-14 relative" data-id="element-3">
      <div className="relative pl-6 md:pl-10 border-l-4 border-accent" data-id="element-4">
        <Quote className="absolute -top-2 -left-2 w-8 h-8 text-accent/20 fill-current transform -translate-x-full -translate-y-1/2 hidden md:block" data-id="element-5" />

        

        {author && <footer className="mt-4 text-sm font-sans font-bold text-gray-500 tracking-wide uppercase" data-id="element-6">
            — {author}
          </footer>}
      </div>
    </motion.div>;
}